import React from 'react';
import { Container } from 'react-bootstrap';
import Heading from '../../../components/Ui/Heading';

const TermsAndConditions = () => {
	return (
		<Container>
			<Heading>Terms & Conditions</Heading>
			<div className="text-center text-uppercase">
				This page is under development.
			</div>
		</Container>
	);
};

export default TermsAndConditions;
